module.exports="object"==typeof self?self.FormData:window.FormData;